import React, { useEffect, useState } from "react";
import { Box, Select, Text, useMantineTheme } from "@mantine/core";

const CHORD_OPTIONS = [
    { value: "ControlLeft+KeyA", label: "Ctrl + A  (Windows)", codes: ["ControlLeft", "KeyA"] },
    { value: "ControlLeft+KeyC", label: "Ctrl + C  (Windows)", codes: ["ControlLeft", "KeyC"] },
    { value: "ControlLeft+KeyV", label: "Ctrl + V  (Windows)", codes: ["ControlLeft", "KeyV"] },
    { value: "ControlLeft+KeyR", label: "Ctrl + R  (Windows)", codes: ["ControlLeft", "KeyR"] },
    { value: "MetaLeft+KeyA", label: "⌘ + A  (macOS)", codes: ["MetaLeft", "KeyA"] },
    { value: "MetaLeft+KeyC", label: "⌘ + C  (macOS)", codes: ["MetaLeft", "KeyC"] },
    { value: "MetaLeft+KeyV", label: "⌘ + V  (macOS)", codes: ["MetaLeft", "KeyV"] },
    { value: "MetaLeft+KeyR", label: "⌘ + R  (macOS)", codes: ["MetaLeft", "KeyR"] },
];

function normalizeStored(raw) {
    if (raw == null || raw === "") return [];
    if (Array.isArray(raw)) return raw.filter(Boolean).map(String);
    if (typeof raw === "string") {
        return raw.split(",").map((s) => s.trim()).filter(Boolean);
    }
    return [];
}

function codesToValue(codes) {
    if (!codes || codes.length === 0) return null;
    const sorted = [...codes].sort((a, b) => a.localeCompare(b));
    const found = CHORD_OPTIONS.find(
        (opt) => [...opt.codes].sort((a, b) => a.localeCompare(b)).join("+") === sorted.join("+")
    );
    return found ? found.value : null;
}

const KeyCombination = (props) => {
    const theme = useMantineTheme();

    const [options, setOptions] = useState({
        keyCombination: normalizeStored(props?.nodeData?.data?.options?.keyCombination),
    });

    useEffect(() => {
        props.handleSetDataBaseModal(options);
    }, [options]);

    const handleChange = (value) => {
        if (!value) {
            setOptions({ keyCombination: [] });
            return;
        }
        const found = CHORD_OPTIONS.find((opt) => opt.value === value);
        setOptions({ keyCombination: found ? found.codes : [] });
    };

    const isDark = theme.colorScheme === "dark";
    const noteBg = isDark ? theme.colors.dark[7] : theme.colors.gray[2];
    const borderCol = isDark ? theme.colors.dark[4] : theme.colors.gray[4];

    return (
        <>
            <Text size="sm" fw={500} mb={6} c="dimmed">
                Key combination
            </Text>
            <Select
                placeholder="Select a key combination…"
                data={CHORD_OPTIONS.map(({ value, label }) => ({ value, label }))}
                value={codesToValue(options.keyCombination)}
                onChange={handleChange}
                clearable
            />
            <Box
                mt={12}
                p="sm"
                style={{
                    borderRadius: theme.radius.sm,
                    backgroundColor: noteBg,
                    border: `1px solid ${borderCol}`,
                }}
            >
                <Text size="sm" fw={600} c="dimmed" mb={8}>
                    Note:
                </Text>
                <Text size="xs" c="dimmed" style={{ lineHeight: 1.55 }}>
                    1. In the Windows system, only Ctrl+A, Ctrl+C, Ctrl+V, and Ctrl+R are supported.
                </Text>
                <Text size="xs" c="dimmed" mt={8} style={{ lineHeight: 1.55 }}>
                    2. In macOS system, only the following key combinations are supported: ⌘A, ⌘C, ⌘V, ⌘R.
                </Text>
            </Box>
        </>
    );
};

export default KeyCombination;
